export { default, type IOtpInputProps } from './otp-input';
